import React from 'react';
import styled from 'styled-components';

import { TextElem } from '../../../../../common/text';
import { MamaTextLogo } from './hero';

export const Content: React.FC<{}> = ({ }) => {
  return (
    <Container id="mama-form">
      <FlexContainerStyled direction="column" align="center" gap={0}>
        <MamaTextLogo
          color="white"
          size="heroSubtitle"
          type="extra-bold"
          tid="MAMA.HOME.CHOOSE_YOUR"
        />

        {/* <FlexContainerStyled direction="row" align="center" gap={10}>
          <div className="">1</div>
          <div className="">2</div>
        </FlexContainerStyled> */}
      </FlexContainerStyled>
    </Container>
  );
};

const CashText = styled(TextElem)`
  font-family: 'Graphik' !important;
  z-index: 1;
  line-height: 0.9em;

  @media screen and (min-width: 698px) and (max-width: 1074px) {
    font-size: 110px;
  }

  @media screen and (max-width: 996px) {
    font-size: 80px;
  }

  @media screen and (max-width: 698px) {
    font-size: 60px;
  }
  @media screen and (max-width: 426px) {
    font-size: 40px;
  }
`;

const Img = styled.img`
  position: absolute;
`;

const StarSvg = styled(Img)`
  z-index: 0;
  width: 1440px;

  @media screen and (min-width: 698px) and (max-width: 1074px) {
    height: 293px;
    width: 916px;
  }
`;

const PrizeText = styled(TextElem)`
  font-family: 'Graphik' !important;
  line-height: 0.8em;
  z-index: 1;

  @media screen and (min-width: 698px) and (max-width: 1074px) {
    font-size: 52px;
  }

  @media screen and (max-width: 996px) {
    font-size: 40px;
  }

  @media screen and (max-width: 698px) {
    font-size: 25px;
  }
`;

const FlexContainer = styled.div<{
  gap?: number;
  direction?: 'column' | 'row';
  align?: 'start' | 'end' | 'center';
}>`
  position: relative;
  display: flex;
  align-items: center;
  align-items: ${({ align = 'center' }) => align};

  flex-direction: ${({ direction }) => direction};
  gap: ${({ gap }) => `${gap}px`};
`;

const FlexContainerStyled = styled(FlexContainer)`
text-align: center;
  @media screen and (max-width: 600px) {
    /* gap: 20px; */
  }

  @media screen and (max-width: 430px) {
    /* gap: 20px; */
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 90px;
  padding: 82px 0px 0px;
`;
